import React from "react"
import { Container } from "react-bootstrap"
import { useSelector } from "react-redux"

const EtiqaHeader = ({ logo }) => {
  const uiData = useSelector(state => state.uiData) // Cannot this will cannot display well progressBar
  // const { maxPageNumber } = uiData

  // const dispatch = useDispatch()
  const { pageNumber } = uiData

  const getStatusClassname = thisSectionPageNumber => {
    let className
    const employerDetailsPageNumber = 7
    const claimDetailsSectionPageNumber = 4

    switch (thisSectionPageNumber) {
      case claimDetailsSectionPageNumber:
        if (pageNumber >= employerDetailsPageNumber) {
          className = "tick"
        } else if (
          pageNumber >= thisSectionPageNumber &&
          pageNumber < employerDetailsPageNumber
        ) {
          className = "current"
        } else {
          className = ""
        }
        break
      default:
        if (pageNumber > thisSectionPageNumber) {
          className = "tick"
        } else if (pageNumber === thisSectionPageNumber) {
          className = "current"
        } else {
          className = ""
        }
        break
    }

    return className
  }

  return (
    <>
      <div className="header">
        <Container>
          <div id="top" className="headNav">
            <nav className="js-nav or--active navNew">
              <div className="logo">
                <a href="https://www.etiqa.com.sg" className="link-home">
                  <img src={logo} alt="Etiqa Logo"></img>
                </a>
              </div>
              <div className="navigate d-block"></div>
            </nav>
          </div>
        </Container>
      </div>
      {pageNumber >= 3 && pageNumber !== 10 && (
        <div className={"containerBody noPadding noMarginTop progressBar"}>
          <div className="progressBarText">
            <span className={"progressBarCheckBox " + getStatusClassname(3)}>
              <div className="uploadDocumentsProgress">
                <p>Upload Documents</p>
              </div>
            </span>
            <span className="progressBarGap"></span>
            <span className={"progressBarCheckBox " + getStatusClassname(4)}>
              <div className="claimDetailsProgress">
                <p>Claim Details</p>
              </div>
            </span>
            <span className="progressBarGap"></span>
            <span className={"progressBarCheckBox " + getStatusClassname(7)}>
              <div className="employerDetailsProgress">
                <p>Employer Details</p>
              </div>
            </span>
            <span className="progressBarGap"></span>
            <span className={"progressBarCheckBox " + getStatusClassname(8)}>
              <div className="otherPoliciesProgress">
                <p>Other Policies of Deceased</p>
              </div>
            </span>
            <span className="progressBarGap"></span>
            <span className={"progressBarCheckBox " + getStatusClassname(9)}>
              <div className="paymentProgress">
                <p>{"Payment & Submit"}</p>
              </div>
            </span>
          </div>
        </div>
      )}
    </>
  )
}
export default EtiqaHeader
